// extracted by mini-css-extract-plugin
export default {"cover_img":"NovelCommonSub_cover_img__xP0fV"};